/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S6_Li5Inputs */

const en_guide_what_is_json_s6_li5 = /** @type {(inputs: Guide_What_Is_Json_S6_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>meaningful key names</strong>: <code>"userName"</code> is better than <code>"un"</code>`)
};

const ko_guide_what_is_json_s6_li5 = /** @type {(inputs: Guide_What_Is_Json_S6_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>의미 있는 키 이름</strong>을 사용하세요: <code>"userName"</code>이 <code>"un"</code>보다 낫습니다`)
};

const ja_guide_what_is_json_s6_li5 = /** @type {(inputs: Guide_What_Is_Json_S6_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>意味のあるキー名</strong>を使用してください: <code>"userName"</code>は<code>"un"</code>よりも良い命名です`)
};

/**
* | output |
* | --- |
* | "Use <strong>meaningful key names</strong>: <code>\"userName\"</code> is better than <code>\"un\"</code>" |
*
* @param {Guide_What_Is_Json_S6_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s6_li5 = /** @type {((inputs?: Guide_What_Is_Json_S6_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S6_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s6_li5(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s6_li5(inputs)
	return ja_guide_what_is_json_s6_li5(inputs)
});